import CONFIGS from "../config/config";
import Api from "../helpers/Api";
const { DEV_BASE_URL } = CONFIGS;

let api = new Api(DEV_BASE_URL);
if (process.env.NODE_ENV === "production") {
  api.setURL(process.env.REACT_APP_BASE_URL);
}

export default api;